// extracted by css-extract-rspack-plugin
export default {"cls1":"PostComments-cls1_M3C","cls2":"PostComments-cls2_cLq PostComments-cls1_M3C","show":"PostComments-show_DiA"};